module.exports = __webpack_public_path__ + "img/articles-hussle.11b05768.svg";